import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createReportSnapshot } from "@services/reportEngine";

export const useCreateReportSnapshot = () => {
  const queryClient = useQueryClient();
  return useMutation(createReportSnapshot, {
    onSuccess: () => queryClient.invalidateQueries(["reportSnapshots"]),
  });
};
